export const errors = {
  cannotConnect: 'Błąd podczas próby dodania połączenia',
  cannotConnectTwoComponents:
    'Nie można połączyć dwóch kroków zależnych lub dwóch kroków zwykłych',
} as const
